import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const LayoutExportERP = styled.div`
  display: flex;
  padding: 16px 24px;
  margin-bottom: 32px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  
  border-radius: 8px;
  background: var(--bs-white);
  /* Elevation / 1 */
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const ExportLabelERP = styled.div`
  display: flex;
  align-items: center;
  gap: 8px; 
`;

export const ExportButtonERP = styled(Button)`
color: #000000DE;
font-weight: 700;
`;

export const ERPLoading = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 64px;
  align-items: center;
  gap: 16px;

  > span {
    color: #394E98;
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    /* Typography/Subtitle 1 */
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 175%; /* 28px */
    letter-spacing: 0.15px; 
  }
`;
